export default "__VITE_ASSET__DUuPglMG__"